var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 14.5C3.00736 14.5 2 13.4926 2 12.25V4.74999C2 3.50735 3.00736 2.5 4.25 2.5H11.75C12.9926 2.5 14 3.50735 14 4.74999L14 12.25C14 13.4926 12.9926 14.5 11.75 14.5H4.25Z",
    fill: "#F96056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1213 6.37866L8 8.49997M8 8.49997L5.87868 10.6213M8 8.49997L10.1213 10.6213M8 8.49997L5.87868 6.37866M14 4.74999L14 12.25C14 13.4926 12.9926 14.5 11.75 14.5H4.25C3.00736 14.5 2 13.4926 2 12.25V4.74999C2 3.50735 3.00736 2.5 4.25 2.5H11.75C12.9926 2.5 14 3.50735 14 4.74999Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSquare);
export default __webpack_public_path__ + "static/media/x-square.58d5dc766e382b27e0b9f108108d5e83.svg";
export { ForwardRef as ReactComponent };